// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fecdd715","453":"0644b93e","553":"38495c85"}[chunkId] + ".chunk.js";
};